import { PEPHealthService } from '@liquid-state/pephealth-client';
import createPEPHealthClient from '@api/pepHealthClient';

let tokenGetter = null;

/** Register how the dashboard obtains the Liquid Gears JWT for pephealth calls. */
export function configurePepHealthTokenSource(getter) {
  tokenGetter = getter;
}

export async function createPepHealthService() {
  if (!tokenGetter) {
    throw new Error('PEP Health token source is not configured');
  }
  const jwt = await tokenGetter();
  const client = await createPEPHealthClient(jwt);
  return new PEPHealthService(client);
}
